import { render, staticRenderFns } from "./showModal-editor.vue?vue&type=template&id=5ad8af81&scoped=true&"
import script from "./showModal-editor.vue?vue&type=script&lang=js&"
export * from "./showModal-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad8af81",
  null
  
)

export default component.exports